import { render, staticRenderFns } from "./pos-print-ticket.vue?vue&type=template&id=a911561c&scoped=true&"
import script from "./pos-print-ticket.vue?vue&type=script&lang=ts&"
export * from "./pos-print-ticket.vue?vue&type=script&lang=ts&"
import style0 from "./pos-print-ticket.vue?vue&type=style&index=0&id=a911561c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a911561c",
  null
  
)

export default component.exports